// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RequestSimulator = (comErro = true, dadoEsperado?: any, timeOut = 3000) => (
  new Promise((resolve, reject) => setTimeout(() => (
    comErro ? reject(new Error('Sem resposta')) : resolve(dadoEsperado)
  ), timeOut))
);
